import React from "react";
import close from "../../../assets/images/model/close.svg"; // Update the path accordingly
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { all, show } from "../../../Store/api/books";
import { classInfo } from "../../../Store/api/classApi";

const ThankUploading = ({
  setGotoConfrimAuthor,
  setUploadLoadingBook,
  setSelectChapter,
  setThanksModel,
  mode,
  bookId,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dispatches = () => {
    if (mode === "app") {
      dispatch(
        all({
          onSuccess: (res) => {
            dispatch(
              show({
                id: bookId,
                onSuccess: (res) => {
                  dispatch(
                    classInfo({
                      onSuccess: () => {
                        navigate("/create/" + bookId);
                      },
                      onError: () => {},
                    })
                  );
                },
                onError: (res) => {},
              })
            );
          },
          onError: (res) => {},
        })
      );
    }

    setThanksModel(false);
    setGotoConfrimAuthor(false);
    navigate("/create/" + bookId);
  };
  return (
    <div
      className="modal custom_background custom_modal_create"
      id="confirm_authors"
      tabIndex="-1"
      style={{ display: "block" }}
      aria-labelledby="confirm_authorsLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              disabled={mode === "app"}
              onClick={() => {
                setGotoConfrimAuthor(false);
                setThanksModel(false);
              }}
            >
              <img src={close} alt="close" />
            </button>
          </div>
          <div className="modal-body-cre">
            <h4>thanks for uploading</h4>
            <p>
              Greyled is still in open-beta and to keep the quality of our
              uploaded materials high, a member of our team manually uploads and
              reviews all materials to ensure it is a one-to-one match.
            </p>
            <p>
              You will receive an email once the upload process is complete.
              While you wait, explore create mode with the Greyled 101 book and
              activity.
            </p>
            <form action="" className="confirm_authors">
              <div className="modal-btn">
                <button
                  type="button"
                  className="btn-black_create mb-24"
                  onClick={() => {
                    dispatches();
                  }}
                >
                  Done
                </button>
                {/*<button
                  type="button"
                  className="btn-white-create"
                  onClick={() => {
                    setUploadLoadingBook(false);
                    setThanksModel(false);
                    dispatches();
                  }}>
                  Go to greyled create
                </button>*/}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankUploading;
